module.exports = __webpack_public_path__ + "static/media/eye-close.bef311d5.svg";